import FileUploaderContainer from './file-uploader-container';

export default FileUploaderContainer;
